import styled from 'styled-components';
import { ChatRowWrapper } from '@guuru/react-chat-messages';

export default styled(ChatRowWrapper)`
  background-color: ${({ $transparent }) =>
    $transparent ? 'transparent' : 'white'};
  border-top: ${({ button, theme }) =>
    button ? 'inherit' : `1px solid ${theme.borderColor}`};
  border-radius: ${({ button }) => (button ? '8px' : 'inherit')};
  padding: 0 1rem;
`;
